import React, { FC, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';

import { EvLinkNavigationTabs, IMenuOption } from '@evinced-private/ui-common';

import { TABS_DAID } from 'data-automation-ids/data-automation-ids';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

interface IMobileSdkSingleTestTabsProps {
	viewId?: SessionViews;
	testId: string;
}

export const MobileSdkSingleTestTabs: FC<IMobileSdkSingleTestTabsProps> = ({
	testId,
	viewId = SessionViews.OVERVIEW
}) => {
	const history = useHistory();

	const handleTabClick = useCallback(
		(tabViewId: SessionViews): void =>
			history.push(RoutesHelper.getMobileSdkTestPath(testId, tabViewId)),
		[history, testId]
	);

	const options: IMenuOption[] = useMemo(
		() => [
			{
				id: SessionViews.OVERVIEW,
				title: 'Overview',
				onClick: () => handleTabClick(SessionViews.OVERVIEW)
			},
			{
				id: SessionViews.ALL_ISSUES,
				title: 'All Issues',
				onClick: () => handleTabClick(SessionViews.ALL_ISSUES)
			}
		],
		[handleTabClick]
	);

	return (
		<div data-automation-id={TABS_DAID}>
			<EvLinkNavigationTabs selectedTabId={viewId} options={options} />
		</div>
	);
};
